<template>
  <div>
    <v-layout>
      <v-flex>
        <v-btn v-if="adminActions" @click="$emit('newDocumentClicked')">
          {{ $t('Nuevo documento') }}
        </v-btn>
        <h1 v-else class="pa-3 display-1">{{ $t('Documentos') }}</h1>
      </v-flex>
      <v-flex>
        <aru-search-entity
          ref="searchEntity"
          :initial-criteria="initialCriteria"
          :add-select-checkbox="addSelectCheckbox"
          :search-config="searchConfig"
          :page="page"
          :entity="entity"
          v-model="items"
          @loading="page = 1"
          @meta="setPagination"
        ></aru-search-entity>
      </v-flex>
    </v-layout>
    <v-list
      v-if="readyToList"
      :two-line="twoLine"
      :three-line="threeLine"
      :subheader="addSelectCheckbox"
    >
      <v-list-tile v-if="addSelectCheckbox">
        <v-list-tile-action>
          <v-btn
            color="primary"
            small
            v-if="allItemsSelected"
            class="select-all-button"
            @click="onCheckAllClicked()"
          ></v-btn>
          <v-btn
            color="info"
            small
            v-if="!allItemsSelected"
            outline
            class="select-all-button"
            @click="onCheckAllClicked()"
          ></v-btn>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-btn flat small @click="onCheckAllClicked()">{{ $t('Seleccionar todos') }}</v-btn>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-btn
            v-if="anySelected"
            color="primary"
            :loading="multiDownloading"
            small
            outline
            class="ml-3 pa-2"
            @click="multiDownload()"
          >
            <v-icon>mdi-download-outline</v-icon>
            {{ $t('Descargar') }}
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-menu v-if="anySelected" class="ml-3">
            <v-btn
              slot="activator"
              color="primary"
              dark
              flat
              small
              outline
              min-width="100"
              class="pa-2"
            >
              {{ $t('Acciones masivas') }}
            </v-btn>
            <v-list>
              <v-list-tile @click="changeMassiveStatus('contabilized')">
                <v-list-tile-title>
                  {{ $t('Contabilizado') }}
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="changeMassiveStatus('in_process')">
                <v-list-tile-title>
                  {{ $t('En proceso') }}
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="changeMassiveStatus('error')">
                <v-list-tile-title>
                  {{ $t('Con errores') }}
                </v-list-tile-title>
              </v-list-tile>

              <v-list-tile @click="changeMassiveStatus('uncontabilized')">
                <v-list-tile-title>
                  {{ $t('Sin contabilizar') }}
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deleteMassiveDocument()">
                <v-list-tile-title class="error--text">
                  {{ $t('Eliminar') }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-action>
      </v-list-tile>
      <document-list-item
        :display="adminActions ? 'adminDisplay' : 'display'"
        :admin-actions="adminActions"
        :add-select-checkbox="addSelectCheckbox"
        v-for="(item, i) in items"
        :default-icon="defaultIcon"
        :key="item.id"
        :entity="item"
        :config="config"
        :level="level"
        @deleteItem="deleteDocument($event, item, i)"
        @checkbox-clicked="onCheckboxClicked"
        @inProcessItem="inProcessItemStatus($event)"
      ></document-list-item>
    </v-list>
    <div class="text-xs-center" v-if="showPagination">
      <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
    </div>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="showDeleteDocumentModal" persistent max-width="300">
          <v-card>
            <v-card-title class="headline">¿Está seguro/a de eliminar este documento?</v-card-title>
            <!-- <v-card-text>¿Está seguro/a de eliminar este documento? <small>Esta acción no es reversible</small></v-card-text> -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" flat @click="showDeleteDocumentModal = false">
                Cancelar
              </v-btn>
              <v-btn color="red darken-1" flat @click="onConfirmDeleteDocument()">Eliminar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruListMixin from '@/mixins/list/AruListMixin.js';
import DocumentListItem from './DocumentListItem';
import AruSearchEntity from '@/components/commons/search/AruSearchEntity';
export default {
  mixins: [AruListMixin],
  components: {
    DocumentListItem,
    AruSearchEntity,
  },
  props: {
    adminActions: {
      type: Boolean,
      default: false,
    },
    fromUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedItems: {},
      multiDownloading: false,
      showDeleteDocumentModal: false,
      documentIdToDelete: null,
    };
  },
  computed: {
    initialCriteria() {
      if (this.adminActions) {
        return {
          myCustomers: true,
        };
      }

      return {};
    },
  },
  mounted() {
    console.log({ paginationInSearch: this.paginationInSearch });
  },
  methods: {
    inProcessItemStatus(id) {
      console.log('DOWNLOADED', id);
      if (!this.fromUser) {
        this.items.forEach(item => {
          if (item.id === id && item.status === 'uncontabilized') {
            item.status = 'in_process';
          }
        });
      }
    },
    getEntities() {
      this.itemsReady = false;
      let config = {};
      config.params = this.$refs.searchEntity ? this.$refs.searchEntity.params : this.params;
      apiCtrl.get('/' + this.entity, config).then(res => {
        if (this.addSelectCheckbox) {
          this.items = res.data.data.map(item => {
            this.$set(item, 'selected', false);
            return item;
          });
        } else {
          this.items = res.data.data;
        }
        if (res.data.hasOwnProperty('meta')) {
          this.pagination = res.data.meta;
          this.showPagination = true;
        }
        this.$emit('entitiesloaded', true);
        this.itemsReady = true;
      });
    },
    changeMassiveStatus(status) {
      const idsIfSelected = (ids, item) => {
        if (item.selected) {
          ids.push(item.id);
        }
        return ids;
      };

      const ids = this.items.reduce(idsIfSelected, []);

      apiCtrl
        .post('/document/change-massive-status', { status: status, documents: ids })
        .then(res => {
          console.log({ DOCUMENTS: res });
          this.items.forEach(item => {
            if (item.selected) {
              item.status = status;
            }
          });
        });
    },
    deleteMassiveDocument() {
      const idsIfSelected = (ids, item) => {
        if (item.selected) {
          ids.push(item.id);
        }
        return ids;
      };

      const ids = this.items.reduce(idsIfSelected, []);

      apiCtrl.post('/document/delete-massive', { documents: ids }).then(res => {
        console.log({ DOCUMENTS: res });
        this.getEntities();
      });
    },
    multiDownload() {
      // let ids = [];
      // let name = '';
      const documentIdsIfSelected = (ids, item) => {
        if (item.selected) {
          ids.push(item.id);
        }
        return ids;
      };

      const documentIds = this.items.reduce(documentIdsIfSelected, []);

      const idsIfSelected = (ids, item) => {
        if (item.selected) {
          if (item.hasOwnProperty('media') && item.media.length > 0) {
            item.media.forEach(media => {
              ids.push(media.id);
            });
          }
        }
        return ids;
      };

      const ids = this.items.reduce(idsIfSelected, []);
      // documents.forEach(entity => {
      //   if (!name) {
      //     name = entity.type + '-' + entity.month;
      //   }
      //   if (entity.hasOwnProperty('media') && entity.media.length > 0) {
      //     entity.media.forEach(media => {
      //       ids.push(media.id);
      //     });
      //   }
      // });
      this.multiDownloading = true;
      return apiCtrl
        .downloadBlob('/document/multi-download', {
          params: {
            name: `download-${Math.random()
              .toString(36)
              .substring(7)}`,
            ids: ids,
            documentIds: documentIds,
          },
        })
        .then(() => {
          this.items.forEach(item => {
            if (documentIds.includes(item.id) && item.status === 'uncontabilized') {
              item.status = 'in_process';
            }
          });
          this.multiDownloading = false;
        })
        .error(() => {
          this.multiDownloading = false;
        });
    },
    onCheckboxClicked(selected, entity) {
      this.$set(entity, 'selected', selected);
    },
    deleteDocument(e, document, i) {
      console.log('Inside doclist', e, document, i);
      this.documentIdToDelete = document.id;
      this.showDeleteDocumentModal = true;
    },
    onConfirmDeleteDocument() {
      apiCtrl.delete('/document/' + this.documentIdToDelete).then(() => {
        this.documentIdToDelete = null;
        this.showDeleteDocumentModal = false;
        this.getEntities();
      });
    },
  },
};
</script>

<style>
.select-all-button {
  width: 16px;
  min-width: 16px;
  height: 16px;
}

.v-list__tile__action .select-all-button {
  margin: 4px;
  padding: 0;
}
</style>
